// CSS
import '../sass/pages/home.scss'

// === WP ALPHA ASSETS
import '@nematis/wp-alpha/assets/js/home'

// === UNIVERS
// Section « Quatre univers » : quatre états (fond, photo, décor, légende, pastille) marqués [data-univers]. La carte
// reste fixe pendant que la section défile et l'univers affiché suit la progression du défilement (barre ambre) : dès
// lg, section de 280vh et carte sous le header (SCSS) ; en dessous, la carte dépasse souvent l'écran, alors sa hauteur
// et celle de la section sont mesurées ici (bas de la carte calé au bas de l'écran, 150vh de défilement). Le clic sur
// une entrée garde le lien vers la page de l'univers. Styles : components/_univers-fonds.scss
const UNIVERS_PROGRESS_MAX = 0.999
const UNIVERS_PROGRESS_DIGITS = 3
const UNIVERS_MOBILE_SCROLL_RATIO = 1.5 // hauteur de défilement de la section en mobile, en écrans
const univers = document.querySelector('.univers')

if (univers) {
  const section = univers.closest('.univers-scroll')
  const items = [...univers.querySelectorAll('.univers-list .nav-item')]
  const panels = [...univers.querySelectorAll('[data-univers]')]
  const counter = univers.querySelector('.univers-compteur')
  const desktop = window.matchMedia('(min-width: 992px)') // lg, comme le sticky du SCSS
  let current = -1

  const show = (index) => {
    if (index === current) {
      return
    }
    current = index
    items.forEach((item, i) => item.classList.toggle('is-active', i === index))
    panels.forEach((panel) => panel.classList.toggle('is-active', Number(panel.dataset.univers) === index + 1))
    if (counter) {
      counter.textContent = `0${index + 1} / 0${items.length}` // quatre univers
    }
  }

  // mobile : hauteur de la section et calage de la carte (desktop : valeurs du SCSS)
  const fit = () => {
    if (!section) {
      return
    }
    if (desktop.matches) {
      section.style.removeProperty('height')
      univers.style.removeProperty('top')

      return
    }
    univers.style.removeProperty('top')
    const cardHeight = univers.offsetHeight
    section.style.height = `${Math.round(cardHeight + window.innerHeight * UNIVERS_MOBILE_SCROLL_RATIO)}px`
    univers.style.top = `${Math.min(0, window.innerHeight - cardHeight)}px`
  }

  // progression dans la section (0 → 1) : quart 1 = univers 1, etc.
  let ticking = false
  const onScroll = () => {
    if (ticking || !section) {
      return
    }
    ticking = true
    window.requestAnimationFrame(() => {
      ticking = false
      const rect = section.getBoundingClientRect()
      const span = Math.max(1, rect.height - window.innerHeight)
      const progress = Math.max(0, Math.min(UNIVERS_PROGRESS_MAX, -rect.top / span))
      univers.style.setProperty('--univers-progression', progress.toFixed(UNIVERS_PROGRESS_DIGITS))
      show(Math.floor(progress * items.length))
    })
  }

  show(0)
  fit()
  onScroll()
  window.addEventListener('scroll', onScroll, {
    passive: true
  })
  window.addEventListener('resize', () => {
    fit()
    onScroll()
  }, {
    passive: true
  })
  window.addEventListener('load', fit) // hauteur définitive de la carte une fois les photos et polices chargées
  desktop.addEventListener('change', () => {
    fit()
    onScroll()
  })
}

// === HERO : OUVERTURE DE RIDEAU
// Le hero charge en état « clair » (fond crème, frise et rideaux au trait, titre sombre). La photo apparaît et les
// rideaux glissent hors champ au bout de 2,3 s, ou plus tôt selon le défilement (80 px) ; la palette passe en
// clair-sur-sombre à mi-chemin. Puis les quatre photos se succèdent en fondu (la première est celle du hero).
// Calques : bloc frère .hero-scene (src/inc/pages/home.php) ; styles : blocks/_hero-banner.scss
const HERO_AUTO_DELAY = 2300
const HERO_SCROLL_SPAN = 80
const HERO_DARK_FROM = 0.45
const HERO_PROGRESS_DIGITS = 3
const HERO_DIAPO_DELAY = 6500
const hero = document.querySelector('.hero-banner-block')
const heroScene = document.querySelector('.hero-scene')

if (hero && heroScene) {
  const heroReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)')
  const heroPicture = hero.querySelector(':scope > picture')
  const diapos = [...heroScene.querySelectorAll('.hero-diapo')]
  const heroTop = hero.getBoundingClientRect().top + window.scrollY
  let heroAuto = false
  let heroDark = false
  let heroTicking = false

  const applyHero = () => {
    const progress = heroAuto ? 1 : Math.max(0, Math.min(1, (window.scrollY - heroTop) / HERO_SCROLL_SPAN))
    heroScene.style.setProperty('--hero-progression', progress.toFixed(HERO_PROGRESS_DIGITS))
    const dark = progress > HERO_DARK_FROM
    if (dark !== heroDark) {
      heroDark = dark
      hero.classList.toggle('is-light', !dark)
      heroScene.classList.toggle('is-dark', dark)
      document.body.classList.toggle('hero-is-light', !dark)
    }
  }

  const onHeroScroll = () => {
    if (heroTicking || heroAuto) {
      return
    }
    heroTicking = true
    window.requestAnimationFrame(() => {
      heroTicking = false
      applyHero()
    })
  }

  applyHero()
  window.addEventListener('scroll', onHeroScroll, {
    passive: true
  })
  window.setTimeout(() => {
    heroAuto = true
    heroScene.classList.add('is-auto')
    applyHero()
    window.removeEventListener('scroll', onHeroScroll)
  }, heroReducedMotion.matches ? 0 : HERO_AUTO_DELAY)

  // diaporama
  if (diapos.length && !heroReducedMotion.matches) {
    let current = 0 // 0 = photo du hero
    if (heroPicture) {
      heroPicture.classList.add('is-active')
    }
    window.setInterval(() => {
      current = (current + 1) % (diapos.length + 1)
      if (heroPicture) {
        heroPicture.classList.toggle('is-active', current === 0)
      }
      diapos.forEach((diapo, index) => diapo.classList.toggle('is-active', index + 1 === current))
    }, HERO_DIAPO_DELAY)
  }
}
